import React from "react";
import "./alertMessage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function AlertMessage({ title, description }) {
  return (
    <div className="contenedor__alerta">
      <FontAwesomeIcon icon="info-circle" class="icono__alerta" />
      <span className="texto__resaltado">{title}</span> {description}
    </div>
  );
}


export default AlertMessage;